import React from 'react';

export const YEAR2_DISABLED_MESSAGE =
  'Year 2 evaluation and portfolio workflows are currently disabled. Year 2 is presently open only for Squad Creator setup.';

export default function Year2DisabledMessage({
  title = 'Year 2 workflows unavailable',
  message = YEAR2_DISABLED_MESSAGE,
  onBack,
}) {
  return (
    <div className="animate-fade-in">
      <div className="placeholder-card" style={{ maxWidth: '720px', margin: '0 auto' }}>
        <h2 style={{ marginTop: 0 }}>{title}</h2>
        <p style={{ color: 'var(--text-muted)', lineHeight: 1.6, marginBottom: onBack ? '20px' : 0 }}>
          {message}
        </p>
        {onBack && (
          <button type="button" className="btn-form-toggle-outlined" onClick={onBack}>
            ← Back
          </button>
        )}
      </div>
    </div>
  );
}